import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const ApnNameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return <Text>{rowData.apn}</Text>;
};

const ApnNameColumn = () => ({
    accessorKey: 'apn',
    header: 'APN',
    size: 1,
    Cell: ({ cell }) => <ApnNameCell cell={cell} />,
});
export default ApnNameColumn;
